import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Sidebar from './components/Sidebar';
import ProtectedRoute from './components/ProtectedRoute';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import AnalysePage from './pages/AnalysePage';
import OffeneSessionsPage from './pages/OffeneSessionsPage';
import SessionArchivPage from './pages/SessionArchivPage';
import LernenPage from './pages/LernenPage';
import CommunityPage from './pages/CommunityPage';
import EinstellungenPage from './pages/EinstellungenPage';
import BehandlungsverfolgungPage from './pages/BehandlungsverfolgungPage';
import { SettingsProvider } from './context/SettingsContext';
import { SessionProvider } from './context/SessionContext';
import { BookmarkProvider } from './context/BookmarkContext';
import { CommunityProvider } from './context/CommunityContext';
import { AuthProvider } from './context/AuthContext';
import './App.css';

// Layout mit Sidebar — nur für eingeloggte Seiten
function AppLayout({ children }) {
  return (
    <div className="app-layout">
      <Sidebar />
      <main className="main-content">{children}</main>
    </div>
  );
}

function App() {
  return (
    <AuthProvider>
      <SettingsProvider>
        <SessionProvider>
          <BookmarkProvider>
            <CommunityProvider>
              <Router>
                <Routes>
                  {/* Öffentliche Routen */}
                  <Route path="/login" element={<LoginPage />} />
                  <Route path="/register" element={<RegisterPage />} />

                  {/* Geschützte Routen — ProtectedRoute leitet zu /login weiter falls nicht eingeloggt */}
                  <Route path="/" element={<Navigate to="/analyse" replace />} />
                  <Route path="/analyse" element={
                    <ProtectedRoute><AppLayout><AnalysePage /></AppLayout></ProtectedRoute>
                  } />
                  <Route path="/analyse/:sessionId" element={
                    <ProtectedRoute><AppLayout><AnalysePage /></AppLayout></ProtectedRoute>
                  } />
                  <Route path="/offene-sessions" element={
                    <ProtectedRoute><AppLayout><OffeneSessionsPage /></AppLayout></ProtectedRoute>
                  } />
                  <Route path="/archiv" element={
                    <ProtectedRoute><AppLayout><SessionArchivPage /></AppLayout></ProtectedRoute>
                  } />
                  <Route path="/lernen" element={
                    <ProtectedRoute><AppLayout><LernenPage /></AppLayout></ProtectedRoute>
                  } />
                  <Route path="/community" element={
                    <ProtectedRoute><AppLayout><CommunityPage /></AppLayout></ProtectedRoute>
                  } />
                  <Route path="/einstellungen" element={
                    <ProtectedRoute><AppLayout><EinstellungenPage /></AppLayout></ProtectedRoute>
                  } />
                  <Route path="/behandlung" element={
                    <ProtectedRoute><AppLayout><BehandlungsverfolgungPage /></AppLayout></ProtectedRoute>
                  } />
                </Routes>
              </Router>
            </CommunityProvider>
          </BookmarkProvider>
        </SessionProvider>
      </SettingsProvider>
    </AuthProvider>
  );
}

export default App;
